import React from "react";
import ErrorIllustration from "./ErrorIllustration";
import Errorsvg from "./ErrorSvg";
// import ErrorIllustration from "./ErrorIllustration";

const Error404 = () => {
  return (
    // <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4">
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="relative w-[70%] max-w-2xl rounded-2xl bg-white  overflow-hidden">
      {/* <div className="relative w-[70%] max-w-2xl rounded-2xl bg-white border border-slate-200 shadow-sm overflow-hidden"> */}
        
        {/* SVG Background */}
        <div className="pt-4 inset-0">
          {/* <ErrorIllustration /> */}
          <Errorsvg/>
        </div>

        {/* Foreground Content */}
        <div className="relative z-10 flex flex-col items-center text-center py-20 pt-10">
          <h1 className="text-7xl font-bold text-slate-900">404</h1>
          <p className="mt-4 text-lg font-medium text-slate-700">
            Sorry, we can’t find that page
          </p>
          <p className="mt-2 text-sm text-slate-500 max-w-sm">
            The page you’re looking for may have been moved or deleted.
          </p>
          <a href="/"  className="mt-6 btn btn-md-primary" >
            Go back home →
          </a>
        </div>
      </div>
    </div>
  );
};

export default Error404;
